import React, { FC } from "react";
import { Field, useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../../wizard/types";
import Autocomplete from "../../../../../components/Autocomplete";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    height: 400,
  },
}));

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const classes = useStyles();

  const { values } = useFormState();

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.root}>
        <Field
          fullWidth
          type="text"
          label="Available Majors"
          options={values.injectedData.majors}
          getOptionDisabled={(option) => !option.isAvailable}
          placeholder="Please Select"
          infoIcon="Choose the majors for which you want to clone the selected program. Majors already in use are displayed as disabled."
          component={Autocomplete}
          multiple={true}
          disableCloseOnSelect={true}
          name={"selectedMajors"}
        />
      </div>
    </form>
  );
};

export default Content;
